import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FwAvatarModule,
  FwBadgeModule,
  FwContainedInputComponent,
  FwDialogService,
  FwDialogsModule,
  FwIconModule,
  FwProgressModule,
  FwSectionHeadingComponent,
  FwSelectMenuModule,
  FwTableModule,
  FwTabPanelComponent,
  FwTabsModule,
  FwTextInputModule,
  FwTooltipDirective,
  FwWrappedInputModule,
} from '@flywheel-io/vision';

import { MaterialModule } from '../material.module';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { BatchJobDialog } from './batch-job-dialog/batch-job-dialog.component';
import { FileBrowserDialog } from './file-browser/file-browser-dialog.component';
import { GearService } from './gear.service';
import { GearAccessDialogComponent } from './gear-access-dialog/gear-access-dialog.component';
import { GearConfigComponent } from './gear-config/gear-config.component';
import { GearInfoComponent } from './gear-info/gear-info.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FwAvatarModule,
    FwBadgeModule,
    FwDialogsModule,
    FwIconModule,
    FwProgressModule,
    FwSelectMenuModule,
    FwTabPanelComponent,
    FwTabsModule,
    FwTableModule,
    FwTextInputModule,
    FwTooltipDirective,
    FwWrappedInputModule,
    GearConfigComponent,
    GearInfoComponent,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    SharedModule,
    FwContainedInputComponent,
    FwSectionHeadingComponent,
    GearAccessDialogComponent,
  ],
  declarations: [BatchJobDialog, FileBrowserDialog],
  providers: [FwDialogService, GearService],
})
export class GearModule {}
